import React from 'react';
import { useNavigate } from 'react-router-dom';

import { PageHeading } from '../../components/Shell/Content';
import DataTable from '../../components/DataTable';
import Badge from '../../components/Badge';

import useAsync from '../../hooks/useAsync';

import { getAllStoragePointsConsumables } from '../../api/storage-points';
import { addPicklist } from '../../api/picklists';

const stockLabels = {
	out: {
		label: 'Out of Stock',
		badge: 'error',
	},
	restock: {
		label: 'Need to restock',
		badge: 'warning',
	},
	instock: {
		label: 'In stock',
		badge: 'success',
	},
};

const getStock = ({ quantity, min, max }) => {
	let stock = 'instock';

	if (quantity === 0) {
		stock = 'out';
	} else if (min && quantity < min) {
		stock = 'restock';
	}

	const label =
		stock === 'restock'
			? `${stockLabels[stock]?.label} (min. ${min})`
			: stockLabels[stock]?.label;

	return {
		badge: (
			<Badge
				isBeta
				status={stockLabels[stock]?.badge}
				size="xxs"
				ghost={stock === 'instock'}
			>
				{label}
			</Badge>
		),
		label,
	};
};

const Inventory = () => {
	const navigate = useNavigate();
	const { value: consumables } = useAsync(getAllStoragePointsConsumables);
	const { execute: onCreatePicklist, status: isLoadingPicklist } = useAsync(
		addPicklist,
		{ immediate: false }
	);

	return (
		<>
			<PageHeading
				actions={[
					{
						name:
							isLoadingPicklist === 'pending'
								? 'Starting picklist...'
								: 'Start Picklist',
						type: 'secondary',
						onClick: () => {
							onCreatePicklist(null, (response) =>
								navigate(`/consumables/picklists/${response.id}`)
							);
						},
					},
					//{ name: 'Add to Inventory' },
				]}
				divider={false}
			/>
			<DataTable
				title="Inventory"
				columns={[
					{
						header: 'NAME',
						accessorKey: 'consumable.name',
						cell: (info) => {
							return info?.getValue() || null;
						},
					},
					{
						header: 'LOCATION',
						accessorKey: 'shelf.storage_point.name',
						cell: (info) => {
							const order =
								info?.row?.original?.shelf?.storage_point?.shelfOrder?.indexOf(
									info?.getValue()?.id
								);
							return info?.getValue() || `Shelf ${order + 1}`;
						},
					},
					{
						header: 'QUANTITY',
						accessorKey: 'quantity',
						cell: (info) => {
							const quantity = info?.row?.original?.quantity;
							const min = info?.row?.original?.minimum;
							const max = info?.row?.original?.maximum;

							return <div className="">{quantity}</div>;
						},
					},
					{
						header: 'STATUS',
						accessorKey: 'quantity',
						cell: (info) => {
							const quantity = info?.row?.original?.quantity;
							const min = info?.row?.original?.minimum;
							const max = info?.row?.original?.maximum;

							return getStock({ quantity, min, max })?.badge;
						},
					},
				]}
				data={{
					rows: consumables || [],
				}}
				usePagination={false}
			/>
		</>
	);
};

export default Inventory;
